import React, { Component } from 'react';
import { compose } from 'recompose';
import CryptoJS from 'crypto-js';
import * as emaiiljs from 'emailjs-com';
import dotenv from 'dotenv';

import Navbar from './navbar/navbar.jsx';
import DirectoryNew from './directory/directory_new.jsx';
import Panel from './panel/panel.jsx';
import { withFirebase } from '../../config/firebase.js';
import { withAuthentication } from '../../config/auth.js';
import './admin.css';

dotenv.config();

class AdminNew extends Component {
    constructor(props) {
        super(props);

        this.state = {
            directoryPath: '', 
            history: [], 
            files: [], 
            selectedFiles: [], 
            email: '', 
            urlKey: ''
        };
    }

    getUrlKey = () => {
        const { firestore } = this.props.firebase;

        const keysRef = firestore.collection('keys');

        keysRef.doc(process.env.REACT_APP_URL_DOC_KEY).get()
        .then(doc => {
            if (doc.exists) {
                this.setState({ urlKey: doc.data().url_key });
            }
        })
        .catch(error => {
            console.log(error);
        });
    }

    encryptURL = url => {
        const { urlKey } = this.state;

        let encrypted = CryptoJS.AES.encrypt(url, urlKey).toString();

        return encodeURIComponent(encrypted);
    }

    selectDirectory = directory => {
        this.setState(prevState => {
            let newHistory = [ ...prevState.history, directory ];
            let newPath = '';

            for (let i = 0; i < newHistory.length; i++) {
                newPath += newHistory[i] + '/';
            }

            return { 
                directoryPath: newPath, 
                history: newHistory, 
                files: [], 
                selectedFiles: []
            };
        });
    }

    prevDirectory = () => {
        this.setState(prevState => {
            let newHistory = [ ...prevState.history ];
            let newPath = '';
            newHistory.splice(-1, 1);

            for (let i = 0; i < newHistory.length; i++) {
                newPath += newHistory[i] + '/';
            }

            return { 
                directoryPath: newPath, 
                history: newHistory, 
                files: [], 
                selectedFiles: []
            };
        });
    }

    rootDirectory = () => {
        this.setState({
            directoryPath: '', 
            history: [], 
            files: [], 
            selectedFiles: []
        });
    }

    getFiles = () => {
        const { storage } = this.props.firebase;
        const { directoryPath } = this.state;

        storage.ref().child(directoryPath).listAll().then(result => {
            let files = [];
            result.items.forEach(item => {
                files.push(item);
            });
            this.setState({ files: files });
        });
    }

    selectFile = event => {
        const { checked, value } = event.target;
        
        if(checked) {
            this.setState(prevState => ({
                selectedFiles: [
                    ...prevState.selectedFiles, 
                    value
                ]
            }));
        }
        else {
            this.setState(prevState => ({
                selectedFiles: prevState.selectedFiles
                    .filter(file => file !== value)
            }));
        }
    }

    onUserInput = event => {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    copyLinks = () => {
        const { selectedFiles } = this.state;
        let links = '';

        if(selectedFiles.length > 0) {
            selectedFiles.forEach(file => {
                links = links + window.location.href + 'pdf/'
                    + this.encryptURL(file) + '\n';
            });

            navigator.clipboard.writeText(links)
                .then(() => {
                    alert('Links successfully copied to clipboard.');
                })
                .catch(() => {
                    alert('There has been an error. Please try again.');
                });
        }
        else {
            alert('No files selected.');
        }
    }

    emailLinks = event => {
        event.preventDefault();

        const { selectedFiles, email } = this.state;
        let links = '';

        if(!email) {
            alert('Please enter an email.');
        }
        else if(selectedFiles.length === 0) {
            alert('No files selected.');
        }
        else {
            selectedFiles.forEach(file => {
                links = links + window.location.href + 'pdf/' 
                    + this.encryptURL(file) + '<br/>';
            });

            const templateParams = {
                from_name: process.env.REACT_APP_FROM_NAME, 
                from_email: process.env.REACT_APP_FROM_EMAIL, 
                to_email: email, 
                message: links
            };

            emaiiljs.send(
                    'default_service', 
                    'template_rjetkus', 
                    templateParams, 
                    'user_js4OjAEDL1OriJV1JHgiS'
                )
                .then(_response => {
                    alert(`Links successfully sent to ${email}.`);
                })
                .catch(_error => {
                    alert('There has been an error. Please try again.');
                });
            
            this.setState({ email: '' });
        }
    }

    componentDidMount() {
        this.getUrlKey();
        this.getFiles();
    }

    componentDidUpdate(_prevProps, prevState) {
        if(prevState.directoryPath !== this.state.directoryPath) {
            this.getFiles();
        }
    }

    render() {
        const directory = {
            selectDirectory: this.selectDirectory, 
            prevDirectory: this.prevDirectory, 
            rootDirectory: this.rootDirectory, 
            selectFile: this.selectFile, 
            encryptURL: this.encryptURL
        };

        const panel = {
            onUserInput: this.onUserInput, 
            copyLinks: this.copyLinks, 
            emailLinks: this.emailLinks
        };

        return (
            <div className='_admin'>
                <Navbar auth={this.props.firebase.auth} />
                <div className='wrapper'>
                    <DirectoryNew {...this.state} {...directory} />
                    <Panel {...this.state} {...panel} />
                </div>
            </div>
        );
    }
}

export default compose(withFirebase, withAuthentication)(AdminNew);